import * as defaultImport from "@splunk/react-icons/CaretSmallDown";
export * from "@splunk/react-icons/CaretSmallDown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
